import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  deleteRadioLocation,
  fetchRadioLocation,
  fetchRadioLocations,
  patchRadioLocation,
  postRadioLocation,
} from '@sophocles/api/radioLocations';

export const loadRadioLocations = createAsyncThunk(
  'inventory/radioLocations/fetchMany',
  async (queryParams, { rejectWithValue }) => {
    try {
      const data = await fetchRadioLocations(queryParams);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const loadRadioLocation = createAsyncThunk(
  'inventory/radioLocations/fetchOne',
  async (organizationId, { rejectWithValue }) => {
    try {
      const data = await fetchRadioLocation(organizationId);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const createRadioLocation = createAsyncThunk(
  'inventory/radioLocations/create',
  async (payload, { rejectWithValue }) => {
    try {
      const data = await postRadioLocation(payload);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const editRadioLocation = createAsyncThunk(
  'inventory/radioLocations/patch',
  async ({ id, ...payload }, { rejectWithValue }) => {
    try {
      const data = await patchRadioLocation(id, payload);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const removeRadioLocation = createAsyncThunk(
  'inventory/radioLocations/delete',
  async (organizationId, { rejectWithValue }) => {
    try {
      await deleteRadioLocation(organizationId);
      return organizationId;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);
